import React from 'react';
import { ArrowRight, TrendingUp } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-50 to-gray-100 py-20 lg:py-32 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 opacity-10">
        <img src="/images/christian-tenguan-RNiK93wcz-U-unsplash.webp" alt="" className="w-full h-full object-cover" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 bg-primary-red/10 text-primary-red px-4 py-2 rounded-full mb-6">
              <TrendingUp size={18} />
              <span className="text-sm font-semibold">Plateforme de référence en France</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" itemProp="headline">
              Votre guide expert pour les meilleurs sites de paris en France
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" itemProp="description">
              Comparez les offres, analysez les bonus et choisissez la plateforme qui correspond à vos attentes. 
              Nous testons chaque site pour vous garantir transparence et sécurité.
            </p>
            
            <div className="flex flex-wrap gap-3 mb-8">
              <a
                href="#offres"
                data-discover="true"
                className="inline-flex items-center justify-center bg-primary-red text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-red-dark transition-colors shadow-lg hover:shadow-xl text-sm"
              >
                Offres
              </a>
              <a
                href="#a-propos"
                data-discover="true"
                className="inline-flex items-center justify-center bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-gray-200 text-sm"
              >
                À propos
              </a>
              <a
                href="#guides"
                data-discover="true"
                className="inline-flex items-center justify-center bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-gray-200 text-sm"
              >
                Guides
              </a>
              <a
                href="#faq"
                data-discover="true"
                className="inline-flex items-center justify-center bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-gray-200 text-sm"
              >
                FAQ
              </a>
              <a
                href="#actualites"
                data-discover="true"
                className="inline-flex items-center justify-center bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-gray-200 text-sm"
              >
                Actualités
              </a>
              <a
                href="#contact"
                data-discover="true"
                className="inline-flex items-center justify-center bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-gray-200 text-sm"
              >
                Contact
              </a>
            </div>
            
            
          </div>
          
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
              <div className="aspect-video rounded-lg overflow-hidden">
                <img src="/images/colton-duke-V5qPDfTTVL8-unsplash.webp" alt="Paris sportifs" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

